var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-participant-card-view"},[_c('event-participant-card-full',{attrs:{"event-id":_vm.eventId,"participant-id":_vm.participantId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }